import React from "react";
import {
  ConfigurableFormElements,
  ConfigurableFormTFn,
  ConfigurableFormElementConfig
} from "../../types";
import { has, get } from "../../utils/helpers";
import FormElement from "./FormElement";
import { DEFAULT_ELEMENTS } from ".";

export interface FormElementsErrors {
  [fieldName: string]: string[];
}

export interface FormElementsProps {
  sharedState: any;
  errors: FormElementsErrors;
  fields: ConfigurableFormElementConfig[];
  elements?: ConfigurableFormElements;
  t: ConfigurableFormTFn;
}

export default function FormElements({
  sharedState,
  errors,
  fields,
  elements = DEFAULT_ELEMENTS,
  t
}: FormElementsProps) {
  const formProps = {
    sharedState,
    errors,
    elements,
    t
  };

  return (
    <>
      {fields.map((field, index) => {
        // Remove the unnecessaries from the props
        const {
          component = "",
          showOnlyIf = true,
          stateToProps,
          props,
          ...rest
        } = field;

        // Don't display
        if (
          !showOnlyIf ||
          !component ||
          !has(elements, component) ||
          !get(elements, component)
        ) {
          return null;
        }

        const key = field.id || field.name || `${index}`;
        const _component = get(elements, component);
        const _props = { ...props, ...rest };

        return (
          <FormElement
            key={key}
            component={_component}
            props={_props}
            stateToProps={stateToProps}
            showOnlyIf={showOnlyIf}
            formProps={formProps}
          />
        );
      })}
    </>
  );
}
